var _mask, _path, _path2, _rect, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _mask2, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path4, _rect16, _rect17, _path5, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path6, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _mask3, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _mask4, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmptyFolder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 160,
    fill: "none",
    viewBox: "0 0 180 160",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.285 71.643l-7.655-14.16c-1.41-2.609-4.136-4.234-7.1-4.234H40.38c-4.458 0-8.072 3.615-8.072 8.075v90.601c0 4.459 3.614 8.075 8.072 8.075h131.548c4.458 0 8.072-3.616 8.072-8.075V83.952c0-4.46-3.614-8.075-8.072-8.075h-70.543c-2.964 0-5.69-1.626-7.1-4.234z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD2BC",
    d: "M94.285 71.643l-7.655-14.16c-1.41-2.609-4.136-4.234-7.1-4.234H40.38c-4.458 0-8.072 3.615-8.072 8.075v90.601c0 4.459 3.614 8.075 8.072 8.075h131.548c4.458 0 8.072-3.616 8.072-8.075V83.952c0-4.46-3.614-8.075-8.072-8.075h-70.543c-2.964 0-5.69-1.626-7.1-4.234z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F07735",
    d: "M86.63 57.483l-1.76.95 1.76-.95zm5.895 15.11l-7.655-14.16 3.519-1.902 7.655 14.16-3.519 1.903zm-7.655-14.16c-1.06-1.962-3.111-3.184-5.34-3.184v-4c3.698 0 7.1 2.028 8.859 5.282l-3.519 1.903zm-5.34-3.184H40.38v-4h39.15v4zm-39.15 0c-3.353 0-6.072 2.72-6.072 6.075h-4c0-5.564 4.508-10.075 10.072-10.075v4zm-6.072 6.075v90.601h-4v-90.6h4zm0 90.601c0 3.356 2.719 6.075 6.072 6.075v4c-5.564 0-10.072-4.512-10.072-10.075h4zM40.38 158h131.548v4H40.38v-4zm131.548 0c3.353 0 6.072-2.719 6.072-6.075h4c0 5.563-4.508 10.075-10.072 10.075v-4zm6.072-6.075V83.952h4v67.973h-4zm0-67.973c0-3.356-2.719-6.075-6.072-6.075v-4c5.564 0 10.072 4.511 10.072 10.075h-4zm-6.072-6.075h-70.543v-4h70.543v4zm-70.543 0c-3.699 0-7.1-2.029-8.86-5.283l3.52-1.902c1.06 1.962 3.11 3.185 5.34 3.185v4z",
    mask: "url(#prefix__a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.808,
    height: 95.867,
    x: 1.366,
    y: 0.366,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    rx: 7,
    transform: "rotate(-30.01 78.623 21.074) skewX(-.021)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    d: "M46 116.379l67.599-39.044 1.29 2.235c1.38 2.392.561 5.45-1.83 6.831l-58.94 34.043c-2.392 1.381-5.45.562-6.83-1.83L46 116.379z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 59.545,
    height: 1.385,
    x: 0.946,
    y: 0.253,
    fill: "#FAFBFC",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(-30.009 94.241 -8.81) skewX(-.019)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 59.545,
    height: 1.385,
    x: 0.946,
    y: 0.253,
    fill: "#FAFBFC",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(-30.009 109.744 -12.96) skewX(-.019)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 59.545,
    height: 1.385,
    x: 0.946,
    y: 0.253,
    fill: "#FAFBFC",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(-30.009 125.247 -17.11) skewX(-.019)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 59.535,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#DDE3EB",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.009 140.978 -20.477) skewX(-.019)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 59.535,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#DDE3EB",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.009 156.3 -24.58) skewX(-.019)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 17.108,
    height: 0.684,
    x: 0.467,
    y: 0.125,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(-30.01 228.564 -85.216) skewX(-.019)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.792,
    height: 4.106,
    rx: 1,
    transform: "rotate(-30.01 217.144 -126.186) skewX(-.02)"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 17.792,
    height: 4.106,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 4,
    mask: "url(#prefix__b)",
    rx: 1,
    transform: "rotate(-30.01 217.144 -126.186) skewX(-.02)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 17.108,
    height: 0.684,
    x: 0.467,
    y: 0.125,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(-30.01 238.826 -46.92) skewX(-.019)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 17.108,
    height: 0.684,
    x: 0.467,
    y: 0.125,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(-30.01 243.933 -48.286) skewX(-.019)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 17.108,
    height: 0.684,
    x: 0.467,
    y: 0.125,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(-30.01 233.669 -86.584) skewX(-.019)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 16.424,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.009 186.946 -32.783) skewX(-.019)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 28.741,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.01 176.679 -71.079) skewX(-.019)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 6.159,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.01 160.253 -132.347) skewX(-.021)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 16.424,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.009 202.268 -36.884) skewX(-.019)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 28.741,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.01 192.002 -75.179) skewX(-.019)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 6.159,
    height: 1.369,
    x: 0.935,
    y: 0.25,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 1.369,
    rx: 0.684,
    transform: "rotate(-30.01 175.575 -136.448) skewX(-.021)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEFF5",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    d: "M45.814 152.078h120.678V67.826H49.937c-2.277 0-4.123 1.846-4.123 4.124v80.128z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 80.796,
    height: 95.88,
    x: 1.083,
    y: 0.909,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    rx: 7,
    transform: "rotate(-5.003 271.899 -505.878) skewX(-.007)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 20.528,
    height: 20.534,
    fill: "#DDE3EB",
    rx: 2,
    transform: "rotate(-5.003 405.64 -653.888) skewX(-.007)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5AF89",
    d: "M54.168 108.168l79.752-6.981.312 3.567c.288 3.301-2.154 6.212-5.455 6.501L60.98 117.19c-3.301.289-6.211-2.153-6.5-5.454l-.312-3.568z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 34.212,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 392.351 -959.413) skewX(-.005)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 34.212,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 486.364 -963.51) skewX(-.005)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 34.212,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 580.38 -967.613) skewX(-.005)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 60.897,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 687.771 -666.306) skewX(-.005)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 60.897,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 781.788 -670.407) skewX(-.005)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 1.368,
    fill: "#FEF9F6",
    rx: 0.684,
    transform: "rotate(-5.002 1280.727 -927.538) skewX(-.005)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 17.791,
    height: 4.107,
    fill: "#FEF9F6",
    rx: 1,
    transform: "rotate(-5.003 1269.68 -1178.03) skewX(-.006)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 1.368,
    fill: "#FEF9F6",
    rx: 0.684,
    transform: "rotate(-5.003 1290.96 -692.554) skewX(-.006)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 1.368,
    fill: "#FEF9F6",
    rx: 0.684,
    transform: "rotate(-5.003 1322.279 -693.918) skewX(-.006)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 1.368,
    fill: "#FEF9F6",
    rx: 0.684,
    transform: "rotate(-5.003 1311.95 -928.804) skewX(-.006)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 969.83 -678.612) skewX(-.005)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 30.107,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 959.565 -913.578) skewX(-.005)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 7.527,
    height: 2.737,
    fill: "#DDE3EB",
    rx: 1.368,
    transform: "rotate(-5.002 943.142 -1289.508) skewX(-.005)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 2.737,
    fill: "#FAE9E1",
    rx: 1.368,
    transform: "rotate(-5.002 1063.85 -682.713) skewX(-.005)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 30.107,
    height: 2.737,
    fill: "#FAE9E1",
    rx: 1.368,
    transform: "rotate(-5.002 1053.586 -917.68) skewX(-.005)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 7.527,
    height: 2.737,
    fill: "#FAE9E1",
    rx: 1.368,
    transform: "rotate(-5.002 1037.163 -1293.6) skewX(-.005)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 80.8,
    height: 95.877,
    x: 0.811,
    y: 1.159,
    fill: "#FAFBFC",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    rx: 7,
    transform: "rotate(10.006 -81.61 572.313) skewX(.012)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5AF89",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    d: "M85.059 110.015l76.871 13.562-.448 2.541c-.48 2.72-3.073 4.536-5.792 4.056L88.667 118.35c-2.72-.48-4.535-3.073-4.056-5.793l.448-2.542z"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 42.923,
    height: 1.385,
    x: 0.562,
    y: 0.802,
    fill: "#FAE9E1",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(10.005 -164.276 732.654) skewX(.009)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 10.615,
    height: 1.385,
    x: 0.562,
    y: 0.802,
    fill: "#EBEFF5",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(10.006 -155.95 637.68) skewX(.011)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 42.923,
    height: 1.385,
    x: 0.562,
    y: 0.802,
    fill: "#FAE9E1",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(10.005 -211.75 728.509) skewX(.009)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 10.615,
    height: 1.385,
    x: 0.562,
    y: 0.802,
    fill: "#FAE9E1",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(10.006 -203.42 633.536) skewX(.011)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 42.923,
    height: 1.385,
    x: 0.562,
    y: 0.802,
    fill: "#FAE9E1",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(10.005 -259.226 724.358) skewX(.009)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 10.615,
    height: 1.385,
    x: 0.562,
    y: 0.802,
    fill: "#FAE9E1",
    stroke: "#DDE3EB",
    strokeWidth: 1.385,
    rx: 0.692,
    transform: "rotate(10.006 -250.89 629.386) skewX(.011)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 59.529,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#DDE3EB",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -299.198 623.978) skewX(.009)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 59.529,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#DDE3EB",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -346.119 619.876) skewX(.009)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 17.106,
    height: 0.684,
    x: 0.278,
    y: 0.396,
    fill: "#FEF9F6",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(10.005 -610.806 714.513) skewX(.009)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 4.105,
    rx: 1,
    transform: "rotate(10.006 -621.966 839.132) skewX(.011)"
  }))), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 17.79,
    height: 4.105,
    fill: "#FEF9F6",
    stroke: "#C1CBD6",
    strokeWidth: 4,
    mask: "url(#prefix__c)",
    rx: 1,
    transform: "rotate(10.006 -621.966 839.132) skewX(.011)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 17.106,
    height: 0.684,
    x: 0.278,
    y: 0.396,
    fill: "#FEF9F6",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(10.005 -600.527 597.238) skewX(.01)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 17.106,
    height: 0.684,
    x: 0.278,
    y: 0.396,
    fill: "#FEF9F6",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(10.005 -616.16 595.872) skewX(.01)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 17.106,
    height: 0.684,
    x: 0.278,
    y: 0.396,
    fill: "#FEF9F6",
    stroke: "#C1CBD6",
    strokeWidth: 0.684,
    rx: 0.342,
    transform: "rotate(10.005 -626.422 713.127) skewX(.01)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 16.422,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#C1CBD6",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -439.969 611.675) skewX(.009)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 28.738,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#C1CBD6",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -450.228 728.935) skewX(.009)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 6.158,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#C1CBD6",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -466.653 916.554) skewX(.009)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 16.422,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#C1CBD6",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -486.89 607.575) skewX(.009)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 28.738,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#C1CBD6",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -497.152 724.833) skewX(.009)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 6.158,
    height: 1.368,
    x: 0.555,
    y: 0.793,
    fill: "#FAE9E1",
    stroke: "#C1CBD6",
    strokeWidth: 1.368,
    rx: 0.684,
    transform: "rotate(10.004 -513.577 912.452) skewX(.009)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.023 71.643l7.655-14.16c1.41-2.609 4.136-4.234 7.101-4.234h39.149c4.458 0 8.072 3.615 8.072 8.075v90.601c0 4.459-3.614 8.075-8.072 8.075H40.38c-4.458 0-8.072-3.616-8.072-8.075V83.952c0-4.46 3.614-8.075 8.072-8.075h70.543c2.964 0 5.69-1.626 7.1-4.234z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEFF5",
    d: "M118.023 71.643l7.655-14.16c1.41-2.609 4.136-4.234 7.101-4.234h39.149c4.458 0 8.072 3.615 8.072 8.075v90.601c0 4.459-3.614 8.075-8.072 8.075H40.38c-4.458 0-8.072-3.616-8.072-8.075V83.952c0-4.46 3.614-8.075 8.072-8.075h70.543c2.964 0 5.69-1.626 7.1-4.234z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5B3C2",
    d: "M125.678 57.483l1.76.95-1.76-.95zm-9.414 13.209l7.655-14.16 3.519 1.902-7.656 14.16-3.518-1.902zm7.655-14.16c1.759-3.255 5.16-5.283 8.86-5.283v4c-2.23 0-4.281 1.222-5.341 3.184l-3.519-1.901zm8.86-5.283h39.149v4h-39.149v-4zm39.149 0c5.564 0 10.072 4.511 10.072 10.075h-4c0-3.356-2.719-6.075-6.072-6.075v-4zM182 61.324v90.601h-4v-90.6h4zm0 90.601c0 5.563-4.508 10.075-10.072 10.075v-4c3.353 0 6.072-2.719 6.072-6.075h4zM171.928 162H40.38v-4h131.548v4zM40.38 162c-5.564 0-10.072-4.512-10.072-10.075h4c0 3.356 2.719 6.075 6.072 6.075v4zm-10.072-10.075V83.952h4v67.973h-4zm0-67.973c0-5.564 4.508-10.075 10.072-10.075v4c-3.353 0-6.072 2.719-6.072 6.075h-4zM40.38 73.877h70.543v4H40.38v-4zm70.543 0c2.229 0 4.28-1.223 5.341-3.185l3.518 1.902c-1.759 3.254-5.16 5.283-8.859 5.283v-4z",
    mask: "url(#prefix__d)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emptyFolder.bc631b47.svg";
export { ForwardRef as ReactComponent };